import { IdeyaRoute } from './router.def.ts'
import {
  dashboard,
  disclaimer,
  firmManagement,
  globalDisclaimer,
  idea,
  inactive,
  login,
  logout,
  myAchievements,
  overallRanking,
  rules,
  statistics,
  tickerManagement,
  userManagement,
} from './router-object.tsx'

export const allPages: IdeyaRoute[] = [
  login,
  logout,
  idea,
  overallRanking,
  myAchievements,
  statistics,
  firmManagement,
  userManagement,
  tickerManagement,
  rules,
  dashboard,
  disclaimer,
  globalDisclaimer,
  inactive,
]

export const routes = {
  login: '/login',
  logout: '/logout',
  summary: '/dashboard',
  idea: '/idea',
  overallRanking: '/ranking/overall-ranking',
  myAchievements: '/ranking/my-achievements',
  statistics: '/statistics',
  firmManagement: '/account-management/firm',
  userManagement: '/account-management/user',
  tickerManagement: '/ticker-management',
  rules: '/rules',
  disclaimer: '/login/disclaimer',
  globalDisclaimer: '/login/global-disclaimer',
  inactive: '/inactive',
}
